import React, { useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Select,
  DatePicker,
  Radio,
  Cascader,
} from "antd";
import "./index.scss";

const { RangePicker } = DatePicker;

const { Option } = Select;
const layout = {
  labelCol: { span: 9 },
  wrapperCol: { span: 15 },
};

export default ({
  cascaderLs,
  inputList,
  selectList,
  dateSearch,
  onSearch,
  onRest,
  onChangeRadio,
  radioList,
  searchParams,
  showRest = true,
}) => {
  const [form] = Form.useForm();
  const onFinish = (values) => {
    onSearch && onSearch(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const reset = () => {
    form.resetFields();
    onRest && onRest();
  };

  const changeRadio = (e) => {
    onChangeRadio && onChangeRadio(e);
  };

  useEffect(() => {
    initSelectValue();
    restoreFrom();
    return () => {};
  }, [selectList, searchParams]);

  const restoreFrom = () => {
    if (searchParams && Object.keys(searchParams).length > 2) {
      form.setFieldsValue(searchParams);
    }
  };

  const initSelectValue = () => {
    selectList &&
      selectList.length &&
      selectList.map((item, index) => {
        if (item.initialValue) {
          form.setFieldsValue({
            [item.name]: item.initialValue,
          });
        }
      });
  };

  return (
    <div className="search-form">
      <Form
        name="searchForm"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        form={form}
        {...layout}
        layout="inline"
      >
        <Row style={{ width: "100%", alignItems: "center" }}>
          {selectList &&
            selectList.length > 0 &&
            selectList.map((item, index) => {
              return (
                <Col key={index} span={item.span ? item.span : 8}>
                  <Form.Item
                    name={item.name}
                    label={item.label}
                    labelCol={{ span: item.labelCol }}
                    wrapperCol={{ span: 24 - item.labelCol }}
                    initialValue={item.defaultValue}
                    rules={[
                      {
                        required: item.required,
                        message: item.message,
                      },
                    ]}
                  >
                    <Select
                      {...item.attr}
                      style={{ width: "100%" }}
                      placeholder={`${item.message}`}
                      onChange={(e) => item.change && item.change(e)}
                    >
                      {item.options.length > 0 &&
                        item.options.map((item, index) => {
                          return (
                            <Option
                              value={item.value}
                              checked={item.checked}
                              key={`key${index}`}
                            >
                              {item.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Col>
              );
            })}
          {cascaderLs &&
            cascaderLs.length > 0 &&
            cascaderLs.map((item, index) => {
              return (
                <Col key={index} span={item.span ? item.span : 6}>
                  <Form.Item
                    name={item.name}
                    label={item.label}
                    labelCol={{ span: item.labelCol }}
                    wrapperCol={{ span: 24 - item.labelCol }}
                    initialValue={item.defaultValue}
                  >
                    <Cascader
                      options={item.options}
                      placeholder="请选择"
                      onChange={(e) => item.change && item.change(e)}
                    />
                  </Form.Item>
                </Col>
              );
            })}
          {dateSearch &&
            dateSearch.length > 0 &&
            dateSearch.map((item, index) => {
              return (
                <Col key={index} span={item.span ? item.span : 8}>
                  <Form.Item
                    name={item.name}
                    label={item.label}
                    labelCol={{ span: item.labelCol }}
                    wrapperCol={{ span: 24 - item.labelCol }}
                    initialValue={item.defaultValue}
                  >
                    {item.tag == "rangePicker" ? (
                      <RangePicker
                        showTime={!item.showTime ? false : true}
                        picker={item.picker}
                      ></RangePicker>
                    ) : (
                      <DatePicker
                        showTime={!item.showTime ? false : true}
                      ></DatePicker>
                    )}
                  </Form.Item>
                </Col>
              );
            })}
          {inputList &&
            inputList.length > 0 &&
            inputList.map((item, index) => {
              return (
                <Col key={index} span={item.span ? item.span : 6}>
                  <Form.Item
                    name={item.name}
                    label={item.label}
                    labelCol={{ span: item.labelCol }}
                    wrapperCol={{ span: 24 - item.labelCol }}
                  >
                    <Input placeholder={`${item.message}`} />
                  </Form.Item>
                </Col>
              );
            })}
          {radioList &&
            radioList.length > 0 &&
            radioList.map((item, index) => {
              return (
                <Col key={index} span={item.span ? item.span : 6}>
                  <Form.Item
                    name={item.name}
                    label={item.label}
                    labelCol={{ span: item.labelCol }}
                    wrapperCol={{ span: 24 - item.labelCol }}
                    initialValue={item.defaultValue}
                  >
                    <Radio.Group onChange={changeRadio}>
                      {item.options &&
                        item.options.map((it) => {
                          return (
                            <Radio key={it.id + "idx"} value={it.id}>
                              {it.name}
                            </Radio>
                          );
                        })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
              );
            })}
          <Col span={24} style={{ textAlign: "center" }}>
            <Button className="search-btn" type="primary" htmlType="submit">
              搜索
            </Button>
          </Col>
          {/*{

						showRest && <Form.Item>
                            <Button className="reset-btn" type="default" htmlType="button" onClick={reset}>
                                重置
                            </Button>
                        </Form.Item>
                    }
					*/}
        </Row>
      </Form>
    </div>
  );
};
